export default "__VITE_ASSET__Bm3bJxrH__"